import { useCallback } from 'react'

import { useRouter, useSearchParams } from 'next/navigation'

import { INTERACTIFY_GALLERY_OPEN_SOURCE, INTERACTIFY_OPEN_SOURCD, INTERACTIFY_PARAM_KEY } from '../constants'

export const useInteractifyParams = () => {
    const router = useRouter()
    const searchParams = useSearchParams()

    const activeInteractifyParam = searchParams.get(INTERACTIFY_PARAM_KEY) || undefined
    const interactifyOpenSource = searchParams.get(INTERACTIFY_OPEN_SOURCD) || undefined
    const isOpenedFromGallery = interactifyOpenSource === INTERACTIFY_GALLERY_OPEN_SOURCE

    const removeInteractifyParam = useCallback(() => {
        const params = new URLSearchParams(searchParams.toString())

        params.delete(INTERACTIFY_PARAM_KEY)
        params.delete(INTERACTIFY_OPEN_SOURCD)

        if (isOpenedFromGallery) {
            const newUrl = `?${params.toString()}#gallery`

            router.replace(newUrl, { scroll: false })

            return
        }

        router.back()
    }, [router, searchParams, isOpenedFromGallery])

    const addInteractifyParam = useCallback(
        ({
            slug,
            isPushingNewRoute = false,
            isOpenningFromGallery = false,
        }: {
            slug: string
            isPushingNewRoute?: boolean
            isOpenningFromGallery?: boolean
        }) => {
            const params = new URLSearchParams(searchParams.toString())

            params.set(INTERACTIFY_PARAM_KEY, slug)

            if (isOpenningFromGallery) params.set(INTERACTIFY_OPEN_SOURCD, INTERACTIFY_GALLERY_OPEN_SOURCE)

            const url = '?' + params.toString()

            if (isPushingNewRoute) router.push(url, { scroll: false })
            else router.replace(url, { scroll: false })
        },
        [router, searchParams]
    )

    return {
        activeInteractifyParam,
        isOpenedFromGallery,
        removeInteractifyParam,
        addInteractifyParam,
    }
}
